export default __webpack_public_path__ + "static/media/twitter.e091825a.svg";